import React from 'react';
import indicatifs from '../../utils/indicatifs';
import SelectIndicatifModal from './SelectIndicatifModal';
import {IoIosArrowDown} from 'react-icons/io'
import { useForm } from 'react-hook-form';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth'
import { app } from '../../utils/Firebase';
import ApiController from '../../redux/actions';
import { toast } from 'react-toastify';

const Login = ({setHasAccount,setShowModal}) => {

    const [showIndicatifsModal,setShowIndicaifsModal] = React.useState(false)
    const [isLoading,setIsLoading] = React.useState(false)
    const [isOtpSent,setIsOtpSent] = React.useState(false)
    const [otp,setOtp] = React.useState()
    const [loginData,setLoginData] = React.useState()

    const [selectedIndicatif,setSelectedIndicatif] = React.useState(indicatifs.filter(item => item.value === 221)[0])

    const {register,formState:{errors},setError,handleSubmit} = useForm()

    const submit = (data) => {
        setIsLoading(true)
        setLoginData(data)

        ApiController.users.isUserNotRegistered("+"+selectedIndicatif.value+data.telephone)
        .then(res => {
            setError('telephone',{message:'Ce numéro n\'est pas encore inscrit!'})
            setIsLoading(false)
        })
        .catch(res => {
            const verifier = new RecaptchaVerifier('container-recaptcha',{},getAuth(app))
            signInWithPhoneNumber(getAuth(app),"+"+selectedIndicatif.value+data.telephone,verifier)
            .then((result)=>{
                setOtp(result)
                setIsOtpSent(true)
                setIsLoading(false)
            })
            .catch(err => {
                setError('telephone',{message:'numéro de téléphone invalid!'})
                setIsLoading(false)
            })
        })
    }

    const confirmOTP =(data)=>{
        setIsLoading(true)
        if(otp){
            otp.confirm(data.otp).then((result)=>{
                let telephone = "+" + selectedIndicatif.value + loginData.telephone

                ApiController.users.loginUser(telephone)
                .then(user =>{
                    setShowModal(false)
                    toast.success('Connexion réuissi',{
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        style:{width:'70vw', right:0,top:'30px',position:'absolute'}
                        })
                })
                .catch(err => console.log(err))
            }).catch(()=>{
                setIsLoading(false)
                setError('otp',{message:'Code de confirmation incorrect!'})
            })
        }
    }


    return (
        <>
        {isOtpSent ? (
                <form className="row login-form" onSubmit={handleSubmit(confirmOTP)}>

                    <div className="col-12 mt-4 text-center">
                    <p className='text-center text-uppercase fw-bold'>Confirmation du code</p>
                        <div className="col-12 mt-3">
                            <p className='text-center'>
                                Vueillez confirmer le code a <span className='fw-bold'>6 chiffres</span> qui vous a été envoyé par SMS au 
                                <br />
                                <span className='fw-bold'>
                                    ( {"+"+ selectedIndicatif.value + loginData?.telephone} )
                                </span>
                            </p>
                            <div className="mt-4">
                                <input {...register('otp',{required:'Veuillez saisir le code de confirmtion'})} type="number" placeholder='code de confirmation' className='input-number input-otp' />
                                {errors.otp && <p className='error-msg'>{errors.otp.message}</p>}
                            </div>
                        </div>
                        <div className="col-12 mt-4">
                            <button disabled={isLoading} className='submit-btn row p-0 m-0 align-items-center'>
                                <div className="col-2"></div>
                                <div className="col-8">
                                    Confirmer
                                </div>
                                <div className="col-2 pt-1">
                                    {isLoading && <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>}    
                                </div>
                            </button>
                        </div>
                    </div>
                </form>
            ):(
             
            <form className="row login-form" onSubmit={handleSubmit(submit)}>
                <div className="col-12 mt-4 text-start">
                    <p className='text-center text-uppercase fw-bold'>Connectez-vous a votre compte</p>
                    
                    <div className="col-12 mt-3">
                        <label className=''>indicatif:</label>
                        <button type='button' className='select-btn' onClick={()=>setShowIndicaifsModal(true)}>
                            <div className="row ps-2">
                                <div className="col-1">
                                    <img src={selectedIndicatif.imgSrc} alt="..." />
                                </div>
                                <div className="col-9 text-start">
                                    <span className='fw-bold me-4'>( +{selectedIndicatif.value} )</span>
                                    <span>{selectedIndicatif.label}</span>
                                </div>
                                <div className="col-2 text-start">
                                    <IoIosArrowDown size={25}/>
                                </div>
                            </div>
                        </button>
                    </div>
                    <div className="col-12 mt-3">
                        <label >Numéro de téléphone</label>
                        <input {...register('telephone',{required:'Veuillez saisir un numéro de téléphone'})} type="number" placeholder='771234567' className='input-number' />
                        {errors.telephone && <p className='error-msg'>{errors.telephone.message}</p>}
                    </div>
                    <div className="col-12 mt-2">
                        <div id='container-recaptcha'></div>
                    </div>
                    <div className="col-12 mt-4">
                        <button disabled={isLoading} className='submit-btn row p-0 m-0 align-items-center'>
                            <div className="col-2"></div>
                            <div className="col-8">
                                Se connecter
                            </div>
                            <div className="col-2 pt-1">
                                {isLoading && <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>}    
                            </div>
                        </button>
                    </div>
                    
                    <p className='text-center mt-3'>Vous n'avez pas de compte?</p>
                    <div className='text-center mb-5'>
                        <button onClick={()=>setHasAccount(false)} type='button' className='text-center fw-bold  text-uppercase text register'>Inscrivez-vous</button>
                    </div>
                </div>
                <SelectIndicatifModal
                    showModal={showIndicatifsModal} 
                    setShowModal={setShowIndicaifsModal} 
                    selectedItem={selectedIndicatif} 
                    setSelectedItem={setSelectedIndicatif}
                    />
            </form>
            )
        }   
        </>
    );
};

export default Login;